import { z } from 'zod'

export const locationSchema = z.object({
    id: z.number().optional(),
    description: z.string().min(1, 'Description is required'),
    address1: z.string().optional(),
    address2: z.string().optional(),
    county: z.string().optional(),
    postcode: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
    category: z.string().optional(),
    categoryId: z.number().nullable().optional(),
    locationId: z.number().nullable().optional(),
    imageFilename: z.string().nullable().optional(),
})

export const createLocationSchema = locationSchema.omit({ id: true })

export const updateLocationSchema = locationSchema.partial().extend({
    description: z.string().min(1, 'Description is required').optional(),
})

export type LocationFormData = z.infer<typeof locationSchema>

